<template>
  <div class="foot">
    <div class="footer">
      <el-row>
        <el-col :span="24" :xs="24" style="background: #51585e;height: 100%;">
          <div class="cleft">
            <div class="fta" @click="fun('/aboutus')">
              {{ $t("navbar.ABOUT") }}
              <i></i>
            </div>
            <div class="fta" @click="fun('/chineseItem')">
              {{ $t("navbar.JOURNALS") }}
              <i></i>
            </div>
            <div class="fta" @click="fun('/bookItem?type=1')">
              {{ $t("navbar.BOOKS") }}
              <i></i>
            </div>
            <div class="fta" @click="fun('/contactItem')">
              {{ $t("navbar.CONTACT") }}
              <i></i>
            </div>
            <div class="fta" @click="fun('/conferenceItem')">
              {{ $t("navbar.CONFERENCE") }}
              <i></i>
            </div>

            <div class="fta_child">
              <span @click="fun('/aboutus')">{{ $t("navbar.ABOUTUS") }}</span>
              <span @click="fun('/editorial')">{{
                $t("navbar.EDITORIAL")
              }}</span>
              <span @click="fun('/opcItem')">{{ $t("navbar.POLICY") }}</span>
              <span @click="fun('/newsItem')">{{ $t("navbar.NEWS") }}</span>
            </div>
            <div class="line5"></div>
            <!-- <div class="in">
              <div class="tit">
                <img src="../../assets/imgs/fr1.png" alt="" />{{
                  $t("navbar.Email")
                }}
              </div>
              <div class="txt">
                contact@omniscient.sg
              </div>
              <div class="tit">
                <img src="../../assets/imgs/fr3.png" alt="" />{{
                  $t("navbar.Telephone")
                }}
              </div>
              <span> +6580301448</span>
            </div> -->
            <p>Copyright © 2026 Omniscient All Right Reserved.</p>
          </div>
        </el-col>
        <!-- <el-col :span="8" :xs="24" style="background: #64696d;">
          <div class="cright">
            <div class="in">
              <div class="tit">
                <img src="../../assets/imgs/fr2.png" alt="" />{{
                  $t("navbar.Location")
                }}
              </div>
              <div class="txt">
                Omniscient Pte. Ltd.
                <br />
                12 Eu Tong Sen Street #07-168 SOHO 2@Central, 059819,Singapore
                <br />
                Omniscient Publishing Limited
                <br />
                53 Whateleys Drive, Kenilworth, Warwickshire, CV8 2GY,
                <span style="font-weight: 700;"> UK</span>
                <br />
                Omniscient Press Limited
                <br />
                Unit 602A, Silvercord, Tower 1, 30 Canton Road, Tsimshatsui,
                <span style="font-weight: 700;"> Hong Kong.</span>
                <br />
              </div>
            </div>
            <div class="in">
              <div class="copy">
                <p>Copyright © 2025 Omniscient All Right Reserved.</p>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    fun(val) {
      document.documentElement.scrollTop = 0;
      this.$router.push(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.foot {
  background: #4e4e4e;
  color: #ffff;

  .footer {
    width: 20rem;
    margin: 0 auto;
    margin-top: 1.5rem;
    align-items: center;
    border-bottom: 1px solid #afabab;
  }

  .fta_child {
    float: left;
    height: 0.7333rem;
    line-height: 0.7333rem;

    span {
      color: #979b9e;
      margin-right: 15px;
    }
  }

  .line5 {
    font-size: 16px;
    height: 0.0833rem;
    width: 100%;
    clear: both;
  }

  .cright {
    background: #64696d;
    // width: 5.5rem;
    padding: 0.3rem 0 0 1.333rem;
  }

  .in {
    padding-bottom: 0.1667rem;
    line-height: 0.5rem;
    min-height: 0.5rem;
  }

  .tit {
    float: left;
    font-weight: bold;
    margin-right: 0.25rem;
    padding-left: 0.5833rem;
    position: relative;

    img {
      display: block;
      width: 0.5rem;
      height: 0.5rem;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .copy {
    display: none;
  }

  .txt {
    float: left;
    margin-right: 30px;
  }

  .cleft {
    width: 15.3333rem;
    float: left;
    padding: 0.5rem 0 0.7rem 5.2rem;

    .fta {
      float: left;
      height: 0.7333rem;
      line-height: 0.6833rem;
      display: inline-block;
      margin: 0 0.5333rem 0.1333rem 0;
      text-transform: uppercase;
      font-size: 0.266667rem;
      font-weight: bold;
      color: #fff;
      position: relative;

      i {
        display: block;
        width: 0.5833rem;
        height: 0.05rem;
        position: absolute;
        left: 0;
        bottom: 0;
        background: #0273c6;
      }
    }
  }

  @media screen and (max-width: 854px) {
    .cright {
      padding-bottom: 10px;

      .in {
        line-height: 0.8rem;
      }

      .tit img {
        top: 1px;
      }
    }

    .cleft {
      display: none;
    }

    .copy {
      float: left;
      display: block;
      font-weight: bold;
    }
  }

  .clear {
    font: 0px Arial;
    line-height: 0;
    height: 0;
    overflow: hidden;
    clear: both;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/FootItem.vue